:host {
  --legend-color: var(--stzh-radio-group-legend-color, #{$headingColor});

  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-radiogroup {
  @include input-description;
  margin: 0;
  padding: 0;
  border: none;

  &__fields {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: space('medium');
  }

  &__legend {
    @include font('heavy');
    @include fontSize('micro');
    color: var(--legend-color);
    padding: 0;
    margin-bottom: space('xsmall');
  }

  &__marker {
    @include fontSize('nano');
    margin-left: calc(-0.25em + #{space('xsmall')});
  }

  &--hide-legend &__legend {
    @include visuallyhidden;
  }

  &--is-invalid &__legend,
  &--has-error &__legend {
    color: $colorError60;
  }

  &--is-disabled &__legend {
    color: $colorGrey60;
  }

  &--direction-horizontal &__fields {
    flex-wrap: wrap;
    flex-direction: row;
    row-gap: space('medium');
    column-gap: space('xxlarge');
  }
}
